export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";